import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

// Connects to data-controller="mapped-field-validation"
export default class extends Controller {
  static values = {
    uri: String
  }

  change(event) {
    let validatorType = event.target.value;
    let uri = this.uriValue
    const query = new URLSearchParams({
      field_validator: validatorType
    });

    get(uri + "?" + query, { responseKind: "turbo-stream" })
  }
}
